define(
    "diy/undo-redo/historyEntry/Factory",
    [
        'diy/undo-redo/constants',
        'diy/undo-redo/historyEntry/Module',
        'diy/undo-redo/historyEntry/Layout',
        'diy/undo-redo/historyEntry/Design',
        'diy/undo-redo/historyEntry/Pages',
        'diy/undo-redo/historyEntry/Style',
        'diy/undo-redo/historyEntry/Theming'
    ],
    /**
     *
     * @param {module.undoRedo.constants} constants
     * @param {function(new:module.undoRedo.HistoryEntry.Module)} HistoryEntryModule
     * @param {function(new:module.undoRedo.HistoryEntry.Layout)} HistoryEntryLayout
     * @param {function(new:module.undoRedo.HistoryEntry.Design)} HistoryEntryDesign
     * @param {function(new:module.undoRedo.HistoryEntry.Pages)} HistoryEntryPages
     * @param {function(new:module.undoRedo.HistoryEntry.Style)} HistoryEntryStyle
     * @param {function(new:module.undoRedo.HistoryEntry.Theming)} HistoryEntryTheming
     * @returns {*}
     */
    function (constants,
              HistoryEntryModule,
              HistoryEntryLayout,
              HistoryEntryDesign,
              HistoryEntryPages,
              HistoryEntryStyle,
              HistoryEntryTheming) {
        'use strict';
        var Factory;

        /**
         * @class module.undoRedo.HistoryEntry.Factory
         * @template module.undoRedo.HistoryEntry.Factory
         * @lends {module.undoRedo.HistoryEntry.Factory.prototype}
         * @constructor
         */
        Factory = Klazz.extend({
            /** @type {module.undoRedo.Api} */
            api: null,

            /**
             *
             * @param {module.undoRedo.Api} api
             */
            initialize: function (api) {
                this.api = api;
            },


            /**
             *
             * @param {String} type
             * @param {Object} payload
             * @return {module.undoRedo.HistoryEntry.Base}
             */
            create: function create(type, payload) {
                /** @type {module.undoRedo.HistoryEntry.Base} */
                var instance = null;
                switch (type) {
                    case constants.historyEntry.MODULE:
                    case constants.historyEntry.MODULE_SECTION:
                        instance = new HistoryEntryModule(payload, this.api);
                        instance.setExecutionType(constants.executionType.SERVER);
                        break;
                    case constants.historyEntry.LAYOUT:
                        instance = new HistoryEntryLayout(payload, this.api);
                        instance.setExecutionType(constants.executionType.SERVER);
                        break;
                    case constants.historyEntry.DESIGN:
                        instance = new HistoryEntryDesign(payload, this.api);
                        instance.setExecutionType(constants.executionType.SERVER);
                        break;
                    case constants.historyEntry.PAGES_STRUCTURE:
                        instance = new HistoryEntryPages(payload, this.api);
                        instance.setExecutionType(constants.executionType.SERVER);
                        break;
                    case constants.historyEntry.STYLE:
                        instance = new HistoryEntryStyle(payload, this.api);
                        instance.setExecutionType(constants.executionType.CLIENT);
                        break;
                    case constants.historyEntry.THEMING:
                        instance = new HistoryEntryTheming(payload, this.api);
                        instance.setExecutionType(constants.executionType.SERVER);
                        break;
                    default:
                        throw new Error('Undefined type ' + type);
                }

                instance.setManager(type);
                return instance;

            },
            /**
             *
             * @param {String} type
             *
             * @param {Object} rawData
             * @param {String} rawData.message
             * @param {Boolean} rawData.isExecutable
             * @param {String} rawData.entryKey
             * @param {String} rawData.entryType
             * @param {String} rawData.entryId
             * @param {String} rawData.undoSessionId
             * @param {Number} rawData.undoSessionIndex
             * @param {Object} rawData.payload
             *
             * @return {module.undoRedo.HistoryEntry.Base}
             */
            load: function load(type, rawData) {
                var instance = this.create(type, rawData);

                instance
                    .setMessage(rawData.message)
                    .setExecutable(rawData.isExecutable)
                    .setKey(rawData.entryKey)
                    .setId(rawData.entryId)
                    .setUndoSessionId(rawData.undoSessionId)
                    .setSessionIndex(rawData.undoSessionIndex)
                    .setEntryType(rawData.entryType)
                    .unserialize(rawData.payload)
                ;
                return instance;
            },
            /**
             *
             * @param {String} type
             * @param {Object} rawData
             * @param {String} message
             * @param {String} undoSessionId
             * @param {Number} undoSessionIndex
             * @param {Boolean=} isExecutable
             */
            build: function build(type, rawData, message, undoSessionId, undoSessionIndex, isExecutable) {
                /** @type {module.undoRedo.HistoryEntry.Base} */
                var instance = this.create(type, rawData);

                instance
                    .setMessage(message)
                    .setUndoSessionId(undoSessionId)
                    .setSessionIndex(undoSessionIndex)
                    .setExecutable(typeof isExecutable !== 'undefined' ? isExecutable : true);
                return instance;
            }
        });

        return Factory;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/historyEntry/Factory.js
 ** module id = 898
 ** module chunks = 0
 **/